import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';

import { getTimezoneOffsetString } from 'constants/helper';

export const useGetTimezoneOffsetEmployee = () => {
  const { timezone } = useSelector(selectLoggedInEmployeeData);
  const currentBrowserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return `${timezone} (${getTimezoneOffsetString(timezone ?? currentBrowserTimezone)})`;
};
